var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"workflows-container",class:{ fullscreen: _vm.fullscreen }},[_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[(_vm.projectWorkflowsStatus === 'success')?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }